import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { IssueType } from './shared'
import { BugtrackerRequest } from '../../bugtrackers/api/shared'
import { getIssueTypes, GetIssueTypesArgs } from './requests/get-issue-types'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseIssueTypesQueryProps {
  organizationUuid: string
  bugtrackerRequest: BugtrackerRequest | null
  projectKey?: string
}

export interface IssueTypesQueryResponse {
  issueTypes: IssueType[] | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseIssueTypesQuery = (
  props: UseIssueTypesQueryProps
) => IssueTypesQueryResponse

export const useIssueTypesQuery: UseIssueTypesQuery = ({
  organizationUuid,
  bugtrackerRequest,
  projectKey
}: UseIssueTypesQueryProps) => {
  const {
    data: issueTypes,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetIssueTypesArgs, IssueType[]>(
    [Query.INTEGRATIONS_ISSUE_TYPES_JIRA, organizationUuid, projectKey],
    getIssueTypes,
    {
      organizationUuid,
      bugtrackerRequest,
      projectKey
    },
    {
      enabled: !!bugtrackerRequest && !!projectKey
    }
  )

  return {
    issueTypes,
    error,
    isError,
    isLoading
  }
}
